var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',{attrs:{"width":"100%","height":"100%","autoplay":"","loop":"","controls":""}},[_c('source',{attrs:{"src":_vm.src,"type":"video/mp4"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }